/**
 * @fileoverview GET handler for the "/alloys/amazon-bedrock/agentic/:app_group_id/external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysAmazonBedrockAgenticExternalId } from "./constants";
import type { GetAlloysAmazonBedrockAgenticExternalIdResult } from "./types";
import { isGetAlloysAmazonBedrockAgenticExternalIdResult } from "./validators";

export const getAlloysAmazonBedrockAgenticExternalId = reactQueryFetcherAdapter(
  alloysAmazonBedrockAgenticExternalId,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysAmazonBedrockAgenticExternalIdResult> => {
    return fetch(
      `/alloys/amazon-bedrock/agentic/${appGroupId}/external_id`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysAmazonBedrockAgenticExternalIdResult
);
